import { jsxs as f, jsx as r, Fragment as E } from "react/jsx-runtime";
import { memo as V, useMemo as y, useCallback as d } from "react";
import { u as j } from "../../styled-components.browser.esm-BFmoFexH.js";
import { Select as M, Col as s } from "antd";
import { IconContainer as A, isEmpty as T } from "@biron-data/react-components";
import O from "./MultipleSortSelector.js";
import { F as U, a as k } from "../../SortSelectorSelect-DSr3KYi4.js";
import { RowWithDefaultValue as B } from "../utils.js";
import { useLanguageResolver as W } from "@biron-data/react-contexts";
import { o as Y, s as b } from "../../dummyModel-DGc8qBEQ.js";
import { useSelectorLayout as q } from "../../layout/useSelectorLayout.js";
const et = V(function({
  value: t,
  onChange: c,
  slicers: l,
  configurations: o,
  getPopupContainer: I,
  groupedOptions: h,
  availableDimensions: w
}) {
  const i = W(), x = q(), g = y(() => l.length > 0 ? w.find((e) => l[0].type === "dimension" && e.code === l[0].dimensionCode) : void 0, [l, w]), F = y(() => [
    {
      label: /* @__PURE__ */ f(R, { children: [
        /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(U, {}) }),
        i.get("configuration-chart-sort.metric-desc")
      ] }),
      value: `${l.length}-DESC`
    },
    {
      label: /* @__PURE__ */ f(R, { children: [
        /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(k, {}) }),
        i.get("configuration-chart-sort.metric-asc")
      ] }),
      value: `${l.length}-ASC`
    }
  ].concat(g ? [{
    label: /* @__PURE__ */ f(R, { children: [
      /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(k, {}) }),
      i.get("configuration-chart-sort.slicer-asc", g.semanticType)
    ] }),
    value: "0-ASC"
  }] : []), [i, g, l.length]), L = d((e) => {
    if (!(!t || t.length === 0)) {
      if (t[e].column === 0 && t[e].asc)
        return "0-ASC";
      if (t[e].column === l.length)
        return `${l.length}-${t[e].asc ? "ASC" : "DESC"}`;
    }
  }, [t, l.length]), u = `${i.get("configuration-add-sort")} ...`, p = d(
    (e) => {
      t && (c == null || c(t.slice(0, e).concat(t.slice(e + 1))));
    },
    [t, c]
  ), S = d(
    (e, n) => {
      const a = t ?? [];
      c == null || c(a.slice(0, e).concat([{
        ...n,
        isDefault: !1
      }], a.slice(e + 1)));
    },
    [t, c]
  ), N = d((e, n) => {
    const [a, C] = n.split("-"), m = Y(h, Number(a));
    S(e, {
      asc: C === "ASC",
      column: Number(a),
      value: m == null ? void 0 : m.label,
      id: m == null ? void 0 : m.id,
      isDefault: !1
    });
  }, [h, S]), $ = d((e) => /* @__PURE__ */ r(M, { options: F, getPopupContainer: I, value: L(e), placeholder: u, style: { width: "100%" }, onSelect: (n) => N(e, n), onChange: (n) => {
    T(n) && p(e);
  } }), [F, I, L, u, N, p]), D = (e) => i.get(`configuration-affect.${e.affect}`);
  return y(() => {
    if (o.length === 0)
      return /* @__PURE__ */ r(E, {});
    switch (o[0].type) {
      case b.ARRAY:
        return /* @__PURE__ */ r(O, { value: t, onChange: c, placeholder: u, handleDelete: p, handleChange: S, groupedOptions: h, layout: x });
      case b.CLASSIC:
        return /* @__PURE__ */ f(B, { $isdefault: t && t.length > 0 ? Number(t[0].isDefault) : 0, children: [
          /* @__PURE__ */ r(s, { span: 2, children: D(o[0]) }),
          /* @__PURE__ */ r(s, { span: 12, children: $(0) })
        ] });
      case b.DOUBLE:
        return o.length < 2 ? /* @__PURE__ */ r(E, {}) : /* @__PURE__ */ f(B, { $isdefault: t && t.length > 0 ? Number(t[0].isDefault) : 0, children: [
          /* @__PURE__ */ r(s, { span: 2, children: D(o[0]) }),
          /* @__PURE__ */ r(s, { span: 14, children: $(0) }),
          /* @__PURE__ */ r(s, { span: 8 }),
          /* @__PURE__ */ r(s, { span: 2, children: D(o[1]) }),
          /* @__PURE__ */ r(s, { span: 14, children: $(1) })
        ] });
      default:
        return o[0];
    }
  }, [o, t, c, u, p, S, h, x, D, $]);
}), R = j.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;
export {
  et as default
};
//# sourceMappingURL=OrderBySelector.js.map
